import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout/dist/masonry.pkgd'; 

$(function () {

    const masonryGrid = $('.grid');
    if (masonryGrid.length > 0) {
        imagesLoaded(masonryGrid[0], () => {
            const msnry = new Masonry(masonryGrid[0], {
                itemSelector: '.masonry-item',
                columnWidth: '.masonry-sizer',
                percentPosition: true,
                gutter: 10
            });
            window.addEventListener('resize', () => {
                msnry.layout();
            });
        });
    }

    const zoneMasonryGrid = $('#zone-cards');
    if (zoneMasonryGrid.length > 0) {
        imagesLoaded(zoneMasonryGrid[0], () => {
            const msnry = new Masonry(zoneMasonryGrid[0], {
                itemSelector: '.zone-card',
                columnWidth: '.zone-sizer',
                percentPosition: true,
                gutter: '.gutter-sizer',
                isAnimated: true
            });

            window.addEventListener('resize', () => {
                msnry.layout();
            });

            $('#toggleInactiveZones').on('change', function () {
                msnry.layout();
            });
        });
    }

    // artwork-filter.blade - use when move to footer and dom is loaded before js
    $('.collapsible').collapse({
        clickQuery: "h5"
    });

    // resources/views/orders/multiple/edit/index.blade.php
    $('.dateFieldNoParse').datepicker({
        forceParse: false
    });

    $('.dateField').datepicker({
        changeMonth: true,
        changeYear: true
    });

    // tables
    $('#couponTable').DataTable({
        "paging": true,
        'pageLength': 25,
        "order": [],
        "responsive": true,
    });

    $('#advSearchResultsTable').DataTable({
        "paging": false,
        "responsive": true,
        "info": false
    });

    $($('[data-table-init="inventory-table"]')).each((i, tableInstance) => {
        $(tableInstance).DataTable({
            "paging": true,
            'pageLength': 25,
            "order": [],
            "responsive": true,
            "autoWidth": false,
        });
    });

    $('#budgetIndexTable').DataTable({
        "paging": false,
        "searching": false,
        "order": [],
        "responsive": true
    });

});